import { ACCOUNT_LOGIN_REQUEST_FAIL, ACCOUNT_LOGIN_REQUEST_SUCCESS, CHANGE_PASSWORD_REQUEST } from '../action.types';
import InitialState from '../initial.state';

export default (state = InitialState.account, action) => {
  switch (action.type) {
    case ACCOUNT_LOGIN_REQUEST_SUCCESS:
      return { ...action.payload }
    case ACCOUNT_LOGIN_REQUEST_FAIL:
      return state;
    case CHANGE_PASSWORD_REQUEST:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/account/account.reducer.js